import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowchevron2LeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="arrowchevron2_left_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M499.499 328.832a42.667 42.667 0 0 0-60.331-60.33L225.835 481.834a42.667 42.667 0 0 0 0 60.33L439.168 755.5a42.667 42.667 0 0 0 60.33-60.331L316.332 512 499.5 328.832zm298.666 0a42.667 42.667 0 0 0-60.33-60.33L524.5 481.834a42.667 42.667 0 0 0 0 60.33L737.835 755.5a42.667 42.667 0 0 0 60.33-60.331L614.997 512l183.168-183.168z"
    />
  </svg>
);
export default SvgArrowchevron2LeftIcon;
